var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',[_c('span',{staticClass:"text-subtitle-2 text-center"},[_vm._v(_vm._s(_vm.headline))]),_c('br'),_c('span',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }